import {StyleSheet} from "react-native";

export default StyleSheet.create({
  activityIndicatorContainer: {
    position: 'absolute',
    flex: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255 ,255 , 0.9)',
    zIndex: 90,
  },
  activityIndicatorWrapper: {
    flex: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center'
  }
})
